import script from "./RouteColorInput.vue?vue&type=script&setup=true&lang=js"
export * from "./RouteColorInput.vue?vue&type=script&setup=true&lang=js"

import "./RouteColorInput.vue?vue&type=style&index=0&id=0b3d03c5&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b3d03c5"]])

export default __exports__